function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import Queue from 'tinyqueue';
export default function polylabel(polygon) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1.0, debug = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // find the bounding box of the outer ring
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = polygon[0][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), x = _step_value[0], y = _step_value[1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var width = maxX - minX;
    var height = maxY - minY;
    var cellSize = Math.max(precision, Math.min(width, height));
    if (cellSize === precision) {
        var result = [
            minX,
            minY
        ];
        result.distance = 0;
        return result;
    }
    // a priority queue of cells in order of their "potential" (max distance to polygon)
    var cellQueue = new Queue([], function(a, b) {
        return b.max - a.max;
    });
    // take centroid as the first best guess
    var bestCell = getCentroidCell(polygon);
    // second guess: bounding box centroid
    var bboxCell = new Cell(minX + width / 2, minY + height / 2, 0, polygon);
    if (bboxCell.d > bestCell.d) bestCell = bboxCell;
    var numProbes = 2;
    function potentiallyQueue(x, y, h) {
        var cell = new Cell(x, y, h, polygon);
        numProbes++;
        if (cell.max > bestCell.d + precision) cellQueue.push(cell);
        // update the best cell if we found a better one
        if (cell.d > bestCell.d) {
            bestCell = cell;
            if (debug) console.log("found best ".concat(Math.round(1e4 * cell.d) / 1e4, " after ").concat(numProbes, " probes"));
        }
    }
    // cover polygon with initial cells
    var h = cellSize / 2;
    for(var x1 = minX; x1 < maxX; x1 += cellSize){
        for(var y1 = minY; y1 < maxY; y1 += cellSize){
            potentiallyQueue(x1 + h, y1 + h, h);
        }
    }
    while(cellQueue.length){
        // pick the most promising cell from the queue
        var _cellQueue_pop = cellQueue.pop(), max = _cellQueue_pop.max, x2 = _cellQueue_pop.x, y2 = _cellQueue_pop.y, ch = _cellQueue_pop.h;
        // do not drill down further if there's no chance of a better solution
        if (max - bestCell.d <= precision) break;
        // split the cell into four cells
        h = ch / 2;
        potentiallyQueue(x2 - h, y2 - h, h);
        potentiallyQueue(x2 + h, y2 - h, h);
        potentiallyQueue(x2 - h, y2 + h, h);
        potentiallyQueue(x2 + h, y2 + h, h);
    }
    if (debug) {
        console.log("num probes: ".concat(numProbes, "\nbest distance: ").concat(bestCell.d));
    }
    var result1 = [
        bestCell.x,
        bestCell.y
    ];
    result1.distance = bestCell.d;
    return result1;
}
function Cell(x, y, h, polygon) {
    this.x = x; // cell center x
    this.y = y; // cell center y
    this.h = h; // half the cell size
    this.d = pointToPolygonDist(x, y, polygon); // distance from cell center to polygon
    this.max = this.d + this.h * Math.SQRT2; // max distance to polygon within a cell
}
// signed distance from point to polygon outline (negative if point is outside)
function pointToPolygonDist(x, y, polygon) {
    var inside = false;
    var minDistSq = Infinity;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = polygon[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var ring = _step.value;
            for(var i = 0, len = ring.length, j = len - 1; i < len; j = i++){
                var a = ring[i];
                var b = ring[j];
                if (a[1] > y !== b[1] > y && x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0]) inside = !inside;
                minDistSq = Math.min(minDistSq, getSegDistSq(x, y, a, b));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return minDistSq === 0 ? 0 : (inside ? 1 : -1) * Math.sqrt(minDistSq);
}
// get polygon centroid
function getCentroidCell(polygon) {
    var area = 0;
    var x = 0;
    var y = 0;
    var points = polygon[0];
    for(var i = 0, len = points.length, j = len - 1; i < len; j = i++){
        var a = points[i];
        var b = points[j];
        var f = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * f;
        y += (a[1] + b[1]) * f;
        area += f * 3;
    }
    var centroid = new Cell(x / area, y / area, 0, polygon);
    if (area === 0 || centroid.d < 0) return new Cell(points[0][0], points[0][1], 0, polygon);
    return centroid;
}
// get squared distance from a point to a segment
function getSegDistSq(px, py, a, b) {
    var x = a[0];
    var y = a[1];
    var dx = b[0] - x;
    var dy = b[1] - y;
    if (dx !== 0 || dy !== 0) {
        var t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x = b[0];
            y = b[1];
        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }
    dx = px - x;
    dy = py - y;
    return dx * dx + dy * dy;
}
